import React, { useState } from "react";
import { useInView } from "react-intersection-observer";
import { StaticImage } from "gatsby-plugin-image";

// components
import VideoModalPlayer from "../../Home/TwinCanHelp/VideoModal";

// styles
import * as styles from "./VideoModal.module.css";

const EmployeeVideoModalComponent = ({
  ctaText = "Play Video",
  onCtaClick = () => {},
  sessionId,
  updateSessionId,
  videoName,
  videoLink,
  videoPageName,
}) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  const [showVideoModal, setShowVideoModal] = useState(false);

  const openVideo = () => {
    setShowVideoModal(true);
    if (onCtaClick) {
      onCtaClick(ctaText);
    }
  };

  const closeVideo = () => {
    setShowVideoModal(false);
  };

  return (
    <>
      <section className={styles.videoModalWrapper}>
        <div ref={ref} className={`scroll_animate ${inView && "inview"}`}>
          <div className={styles.videoContent}>
            <div className={styles.bannerContainer}>
              {/* Desktop Banner */}
              <StaticImage
                src="../../../images/forEmployee/emp-banner-desk.png"
                alt="Employee Wellness"
                className={styles.desktopBanner}
                loading="lazy"
              />
              {/* Mobile Banner */}
              <StaticImage
                src="../../../images/forEmployee/emp-banner-mob.png"
                alt="Employee Wellness"
                className={styles.mobileBanner}
                loading="lazy"
              />

              {/* Overlay Content */}
              <div className={styles.overlayContent}>
                <div className={styles.ctaContainer}>
                  <h2 className={styles.ctaTitle}>
                    See how Evergreen by Twin Health works
                  </h2>
                  <button
                    className={styles.playButton}
                    onClick={openVideo}
                    aria-label="Play Video"
                  >
                    <span className={styles.playButtonText}>{ctaText}</span>
                    <StaticImage
                      src="../../../images/icons/emp-playicn.png"
                      alt="Play"
                      className={styles.playIcon}
                      loading="lazy"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Video Modal */}
      <VideoModalPlayer
        show={showVideoModal}
        onHide={closeVideo}
        videoLink={videoLink}
        videoName={videoName}
        sessionId={sessionId}
        updateSessionId={updateSessionId}
        videoPageName={videoPageName}
      />
    </>
  );
};

export default EmployeeVideoModalComponent;
